import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';

/* -------- Components -------- */
import Notification from "./Notification.jsx";
/* -------- ------- -------- */

/* -------- packages -------- */
import { Link, NavLink } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col, Nav, NavItem, TabContent, TabPane } from "reactstrap";
import { useTranslation } from "react-i18next";
import SimpleBar from "simplebar-react";
/* -------- ------- -------- */


/* -------- Redux -------- */
import { useDispatch } from "react-redux";
import { updateNotificationRequest, fetchNotificationsRequest } from "../../../store/notifications/actions.js";
import { useSelector } from "react-redux";
/* -------- ------- -------- */

const NotificationDropdown = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  
  const { notifications } = useSelector(state => state.Notifications);
  const user = useSelector(state => state.Login.user);

  const [menu, setMenu] = useState(false); // open/close notification dropdown
  const [myNotifications, setMyNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0); // count of unread notifications
  const [readCount, setReadCount] = useState(0); // count of read notifications

  const [archivedNotifications, setArchivedNotifications] = useState([]);
  const [newNotifications, setNewNotifications] = useState([]); // Renommé de allNotifications

  const [activeTab, setActiveTab] = useState('1'); // selected tab in notification modal (1 = new, 2 = archived)
  
  /* ------------- get all notifications -------------- */
  useEffect(() => {
    dispatch(fetchNotificationsRequest());
  }, [dispatch]); 
  /* --------------------------- */
  
  /* ------------- filter notifications of logged user -------------- */
  useEffect(() => {
    let notifTemp = [];
    
    notifications.map((notif) => {
      if (notif.userForId == user.id) {
        notifTemp.push(notif);
      }
    });
    
    setMyNotifications(notifTemp);
  }, [notifications, user.id]);
  /* --------------------------- */
  
  /* ------------- count unread notifications and categorize -------------- */
  useEffect(() => {
    // Séparer les notifications archivées et nouvelles
    const archived = myNotifications.filter((notif) => notif.isArchived === true);
    const newNotifs = myNotifications.filter((notif) => notif.isArchived === false);
    
    setArchivedNotifications(archived);
    setNewNotifications(newNotifs);
    
    // Compter seulement les non-lues parmi les nouvelles (non-archivées)
    setUnreadCount(newNotifs.filter(notification => !notification.isRead).length);
    
    setReadCount(myNotifications.filter(notification => notification.isRead === true).length);
  }, [notifications, myNotifications]);
  /* --------------------------- */

  const readNotification = (item) => {
    item.isRead = true;
    dispatch(updateNotificationRequest(item));
  };

  const handleChangeTab = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <Dropdown
      id="projNotifDropdown"
      isOpen={menu}
      toggle={() => setMenu(!menu)}
      className="dropdown d-inline-block"
      tag="li"
    >
      <DropdownToggle
        className="btn header-item noti-icon position-relative"
        tag="button"
        id="projNotifToggleDropdown"
      >
        <i className={(unreadCount > 0) ? "postionIconHeader bx bxs-bell-ring bx-tada" : "postionIconHeader bx bxs-bell"} />
        <span className={`badge rounded-pill ${unreadCount > 0 ? 'bg-danger' : 'bx bxs-bell'}`}>
          {unreadCount > 0 ? unreadCount : ''}
        </span>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu dropdown-menu-lg p-0 dropdown-menu-end">
        <SimpleBar id="projNotifContainer" style={{ height: "330px" }}>
          <div className="notificationsContainer">
            <Nav tabs>
              <NavItem className={(activeTab === '1') ? 'activeTab' : ''} onClick={() => { handleChangeTab('1'); }}>
                <NavLink>
                  {t('newNotif')} <span>{newNotifications.length}</span>
                </NavLink>
              </NavItem>

              <NavItem className={(activeTab === '2') ? 'activeTab' : ''} onClick={() => { handleChangeTab('2'); }}>
                <NavLink>
                  {t('archived')} <span>{archivedNotifications.length}</span>
                </NavLink>
              </NavItem>
            </Nav>
        
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1"> {/* new notifications (non-archived) */}
                {newNotifications.length ? newNotifications.map((notification, index) => {
                  if (notification) {
                    return (
                      <Notification 
                        key={'projNotif' + index}
                        notification={notification}
                        markAsReadFunction={readNotification}
                        activeTab={activeTab}
                        isLastNotification={false}
                      />
                    );
                  }
                })
                : 
                (
                  <p key={'projEmptyNotif'} className="emptyNotif">{t('emptyNotification')}</p>
                )
                }
              </TabPane>

              <TabPane tabId="2"> {/*  archived notifications */}
                {archivedNotifications.length ? archivedNotifications.map((notification, index) => {
                  return (
                    <Notification 
                      key={'projNotif' + index}
                      notification={notification}
                      markAsReadFunction={readNotification}
                      activeTab={activeTab}
                      isLastNotification={false}
                    />
                  );
                })
                : 
                (
                  <p key={'projEmptyNotif'} className="emptyNotif">{t('emptyNotification')}</p>
                )
                }
              </TabPane>
            </TabContent>
          </div>
        </SimpleBar>
      </DropdownMenu>
    </Dropdown>
  );
};

NotificationDropdown.propTypes = {
  t: PropTypes.any
};

export default NotificationDropdown;